import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=0bb77cf0&scoped=true&"
import script from "./Paragraph.vue?vue&type=script&lang=js&"
export * from "./Paragraph.vue?vue&type=script&lang=js&"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=0bb77cf0&lang=scss&scoped=true&"
import style1 from "./Paragraph.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb77cf0",
  null
  
)

export default component.exports